<script>
export default {
  props: {
    routes: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getRouteTitle(route) {
      return typeof route.title === 'function' ? route.title() : route.title
    },
  },
}
</script>

<template>
  <v-list-item
    v-for="route in routes"
    :key="route.name"
    :to="route"
    :exact="route.exact"
  >
    <template v-if="route.icon" v-slot:prepend>
      <v-icon>{{ route.icon }}</v-icon>
    </template>
    <v-list-item-title>{{ getRouteTitle(route) }}</v-list-item-title>
  </v-list-item>
</template>

<style lang="scss" module>
.active {
  @extend .black, .b, .fw6 !optional;

  cursor: default;
}
</style>
